import React from 'react'

import { Modal } from '@/components/ui'

import type { AlertAcknowledgementErrorModalProps } from '../types'

const AlertAcknowledgementErrorModal: React.FC<AlertAcknowledgementErrorModalProps> = ({
  show,
  title,
  error,
  onClose,
}) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      title={title}
      variation="danger"
      danger
      bodyContent={<p>{error}</p>}
      footerButtons={[
        {
          label: 'Close',
          onClick: onClose,
          class: 'border-black btn-sm',
        },
      ]}
    />
  )
}

export default AlertAcknowledgementErrorModal
